import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
const apiURL = "company";

export const getCompanyGlobalList = async (filter: any = {}) => {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: {
				filter: JSON.stringify(filter),
			},
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		throw error;
	}
};

export const getCompanyList = (
	tenantKey: any,
	company_keys: any = [],
	isLookup: any = false,
	company_type: any = [] // Additional filter to get companies by company type
) => {
	const filter: any = {};

	if (company_keys?.length == 0 && !isLookup) {
		filter.uuid = { $in: company_keys };
	}

	if (Array.isArray(company_type) && company_type.length > 0) {
		filter.company_type = { $in: company_type };
	} else if (company_type) {
		filter.company_type = company_type;
	}

	return new Promise((resolve, reject) => {
		axios
			.get(`${url}/${tenantKey}/${apiURL}`, {
				params: {
					filter,
				},
				...AuthHeader,
			})
			.then((_data: any) => {
				if (_data?.data && _data.data.length) {
					resolve(_data.data);
				} else {
					resolve(null);
				}
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const addCompanyItem = (tenantKey: any, data: any) => {
	const _url = tenantKey
		? `${url}/${tenantKey}/${apiURL}/addCompany`
		: `${url}/${apiURL}/addCompany`;
	console.log("data: ", data);
	return new Promise((resolve, reject) => {
		axios
			.post(_url, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
				console.log("_data: ", _data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const updateCompanyItem = (
	tenantKey: any,
	uuid: any,
	data: any,
	prevData: any
) => {
	const _url = tenantKey
		? `${url}/${tenantKey}/${apiURL}/updateCompany`
		: `${url}/${apiURL}/updateCompany`;
	return new Promise((resolve, reject) => {
		axios
			.put(
				_url,
				{
					filter: { uuid: uuid },
					data: data,
					options: { upsert: true, new: true },
					prevData: prevData,
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data);
				console.log("_data: ", _data);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteCompanyItem = (tenantKey: any, uuid: any) => {
	const _url = tenantKey
		? `${url}/${tenantKey}/${apiURL}/deleteCompany`
		: `${url}/${apiURL}/deleteCompany`;
	const _filter = tenantKey
		? { filter: { uuid: uuid } }
		: { filter: JSON.stringify({ uuid: uuid }) };
	return new Promise((resolve, reject) => {
		axios
			.delete(_url, {
				params: _filter,
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
